import moment from 'moment-timezone';

const getTimezone = (timeZone) => {
  if (timeZone?.trim().length > 0) {
    const tz = timeZone?.trim();
    if (moment.tz.zone(tz)) {
      return tz;
    }
  }
  return '';
};

const SYSTEM_TIME_ZONE =
  getTimezone(window.env.SYSTEM_TIME_ZONE) || 'America/New_York';

export const TIME_ZONE = getTimezone(window.env.TIME_ZONE) || 'UTC';
export const LOCALE = 'en-US';
export const FORMAT_DATE = 'MM/DD/YYYY';
export const FORMAT_TIME = 'hh:mm:ss A';
export const FORMAT_DATE_TIME = FORMAT_DATE + ' ' + FORMAT_TIME;

export const getMonthAndYear = (dateStr) => {
  const date = new Date(dateStr);
  const options = { year: 'numeric', month: 'long', timeZone: TIME_ZONE };
  return new Intl.DateTimeFormat(LOCALE, options).format(date);
};

export const isWeekend = (dateStr) => {
  return ['Sat', 'Sun'].includes(moment(dateStr).format('ddd'));
};

export const unixToMoment = (v) => {
  if (!v) return;

  const secs = v.seconds * 1000;
  const nanos = v.nanos / 1000000;

  return moment(secs + nanos).utc();
};

export const unixClockToMoment = (v) => {
  const mDate = unixToMoment(v);

  if (!mDate) return;

  return mDate.tz(SYSTEM_TIME_ZONE, true);
};

// export const unixClockToString = (v, format = FORMAT_DATE_TIME) => {
//   const mDate = unixClockToMoment(v);

//   if (!mDate) return '';

//   return mDate.format(format);
// };
